import type { ReactNode } from "react";
import { LocaleProvider } from "@itaas/core/i18n/LocaleContext";
import { TenantProvider } from "@itaas/core/tenant/TenantContext";
import { SuiteAuthProvider } from "@/auth/SuiteAuthProvider";

interface SuiteProvidersProps {
  children: ReactNode;
}

export function SuiteProviders({ children }: SuiteProvidersProps) {
  return (
    <LocaleProvider>
      <SuiteAuthProvider>
        <TenantProvider>{children}</TenantProvider>
      </SuiteAuthProvider>
    </LocaleProvider>
  );
}
